import { graphql } from "relay-runtime"

const deActivateComfortSignatureSubscription = graphql`
  subscription deActivateComfortSignatureSubscription {
    de_activateTelematikInfrastructureComfortSignature {
      isActivated
      errorMessage
      errorType
    }
  }
`

export { deActivateComfortSignatureSubscription }
